// Temporarily paused at the owner's request; FAQ content/components stay intact.
export const FAQ_ENABLED = false;